var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roll-create" } }, [
    _c("div", { staticClass: "rc-header" }, [
      _c("span", {
        staticClass: "rc-header-back el-icon-arrow-left",
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("h1", { staticClass: "rc-header-title" }, [_vm._v("创建ROLL房")]),
      _c("div", { staticClass: "rc-header-actions" }, [
        _c(
          "button",
          {
            staticClass: "rc-btn rc-btn--next",
            attrs: { disabled: _vm.submitting },
            on: { click: _vm.handleNext },
          },
          [_vm._v("下一步")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "rc-form-container" }, [
      _c("div", { staticClass: "rc-form-col" }, [
        _c("div", { staticClass: "rc-column-title" }, [_vm._v("基础设置")]),
        _c("div", { staticClass: "rc-form-item" }, [
          _c("label", { staticClass: "rc-label" }, [_vm._v("房间名")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.roomName,
                expression: "form.roomName",
              },
            ],
            staticClass: "rc-input",
            attrs: { type: "text", placeholder: "请输入房间名" },
            domProps: { value: _vm.form.roomName },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "roomName", $event.target.value)
              },
            },
          }),
        ]),
        _c("div", { staticClass: "rc-form-item" }, [
          _c("label", { staticClass: "rc-label" }, [_vm._v("活动简介")]),
          _c("div", { staticClass: "rc-textarea-wrap" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.desc,
                  expression: "form.desc",
                },
              ],
              staticClass: "rc-textarea",
              attrs: {
                placeholder: "非必填项，不填则不显示，不超过100字",
                maxlength: "100",
              },
              domProps: { value: _vm.form.desc },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "desc", $event.target.value)
                },
              },
            }),
            _c("span", { staticClass: "rc-char-count" }, [
              _vm._v(_vm._s(_vm.form.desc.length) + "/100"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "rc-form-item" }, [
          _c("label", { staticClass: "rc-label" }, [_vm._v("活动密码")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.password,
                expression: "form.password",
              },
            ],
            staticClass: "rc-input",
            attrs: {
              type: "text",
              placeholder: "设置后玩家参与活动需输入密码",
            },
            domProps: { value: _vm.form.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "password", $event.target.value)
              },
            },
          }),
        ]),
        _c("div", { staticClass: "rc-form-item" }, [
          _c("label", { staticClass: "rc-label" }, [_vm._v("邀请码")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.promoteCodes,
                expression: "form.promoteCodes",
              },
            ],
            staticClass: "rc-input",
            attrs: { type: "text", placeholder: "不填表示无限制 多个以,间隔" },
            domProps: { value: _vm.form.promoteCodes },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "promoteCodes", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "rc-form-col" }, [
        _c("div", { staticClass: "rc-column-title" }, [_vm._v("开奖设置")]),
        _c("div", { staticClass: "rc-form-grid-2" }, [
          _c(
            "div",
            { staticClass: "rc-form-item" },
            [
              _c("label", { staticClass: "rc-label" }, [_vm._v("开奖时间")]),
              _c("el-date-picker", {
                staticClass: "rc-date-input",
                attrs: {
                  type: "datetime",
                  placeholder: "开奖时间",
                  "popper-class": "rc-date-popper",
                  "picker-options": _vm.expirTimePickerOptions,
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                on: { change: _vm.handleExpirTimeChange },
                model: {
                  value: _vm.form.expirTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expirTime", $$v)
                  },
                  expression: "form.expirTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "rc-form-item rc-form-item--center" },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "rc-checkbox",
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [_vm._v("是否人满立即开奖")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "rc-form-item" }, [
          _c("label", { staticClass: "rc-label" }, [_vm._v("参与人数")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.form.maxUser,
                expression: "form.maxUser",
                modifiers: { number: true },
              },
            ],
            staticClass: "rc-input",
            attrs: { type: "number", min: "1", placeholder: "0" },
            domProps: { value: _vm.form.maxUser },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "maxUser", _vm._n($event.target.value))
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _c("div", { staticClass: "rc-threshold-card" }, [
          _c("div", { staticClass: "rc-threshold-card-header" }, [
            _vm._v("充值门槛设置"),
          ]),
          _c("div", { staticClass: "rc-threshold-card-body" }, [
            _c(
              "div",
              { staticClass: "rc-form-item" },
              [
                _c("label", { staticClass: "rc-label" }, [
                  _vm._v("充值金额开始时间"),
                ]),
                _c("el-date-picker", {
                  staticClass: "rc-date-input",
                  attrs: {
                    type: "datetime",
                    placeholder: "开始时间",
                    "popper-class": "rc-date-popper",
                    format: "yyyy-MM-dd HH:mm:ss",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  model: {
                    value: _vm.form.payStartTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "payStartTime", $$v)
                    },
                    expression: "form.payStartTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "rc-form-item" },
              [
                _c("label", { staticClass: "rc-label" }, [
                  _vm._v("充值金额结束时间"),
                ]),
                _c("el-date-picker", {
                  staticClass: "rc-date-input",
                  attrs: {
                    type: "datetime",
                    placeholder: "结束时间",
                    "popper-class": "rc-date-popper",
                    format: "yyyy-MM-dd HH:mm:ss",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  model: {
                    value: _vm.form.payEndTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "payEndTime", $$v)
                    },
                    expression: "form.payEndTime",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "rc-form-item" }, [
              _c("label", { staticClass: "rc-label" }, [_vm._v("充值金额")]),
              _c("div", { staticClass: "rc-input-unit-wrap" }, [
                _c("span", { staticClass: "prefix" }, [_vm._v("¥")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.form.recharge,
                      expression: "form.recharge",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "rc-input",
                  attrs: { type: "number", min: "0", placeholder: "0" },
                  domProps: { value: _vm.form.recharge },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.form,
                        "recharge",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c("span", { staticClass: "suffix" }, [_vm._v("金币")]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }